import axios from '@/api/config';

const agentLevel = {
  getAgentLevelById(data) {
    return axios.get(`${process.env.BASE_URL}/agentLevel/getAgentLevel/` + data, {});
  },
  getAgentLevel(data) {
    return axios.get(`${process.env.BASE_URL}/agentLevel/getAgentLevel`, {params: data});
   },
  getAgentLevelList(data) {
    return axios.get(`${process.env.BASE_URL}/agentLevel/getAgentLevelList`, {params: data});
  },
  getAgentLevelTree(data) {
    return axios.get(`${process.env.BASE_URL}/agentLevel/getAgentLevelTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/agentLevel/pageList`, data);
  },
  addAgentLevel(data) {
    return axios.post(`${process.env.BASE_URL}/agentLevel/addAgentLevel`, data);
  },
  updateAgentLevel(data) {
    return axios.put(`${process.env.BASE_URL}/agentLevel/updateAgentLevel`, data);
  },
  deleteAgentLevel(data) {
    return axios.delete(`${process.env.BASE_URL}/agentLevel/deleteAgentLevel`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/agentLevel/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/agentLevel/importData`, data);
  }
}

export default agentLevel;



// WEBPACK FOOTER //
// ./src/api/agentLevel.js